import { HorizontalGradientBar } from './HorizontalGradientBar';
import { Tooltip, Typography } from '@analytical-alley/ui';
import { IconExclamationCircle } from '@tabler/icons-react';
import React from 'react';

type StatRowProps = {
    label: string;
    value: number | null | undefined;
    tooltip?: string;
    min: number;
    max: number;
    gradient: string;
    formatValue: (v: number) => string;
};

export const StatRow = ({
    label,
    tooltip,
    value,
    min,
    max,
    gradient,
    formatValue,
}: StatRowProps) => (
    <div className="flex flex-col gap-1">
        <div className="flex justify-between items-baseline">
            <div className="flex items-center gap-1">
                <Typography variant="bodyS" tooltip={tooltip}>
                    {label}
                </Typography>
            </div>
            <span className="text-white text-sm font-medium">
                {value != null ? formatValue(value) : ' - '}
            </span>
        </div>
        {value != null ? (
            <div className="flex items-center gap-2">
                <span className="text-white/50 text-[10px] w-8 text-right shrink-0">
                    {min}
                </span>
                <HorizontalGradientBar
                    value={value}
                    min={min}
                    max={max}
                    gradient={gradient}
                />
                <span className="text-white/50 text-[10px] w-8 text-left shrink-0">
                    {max}
                </span>
            </div>
        ) : null}
    </div>
);
